import React from 'react';
import { withFormsy, propTypes as formsyProptypes } from 'formsy-react';
import TextField from '@material-ui/core/TextField';

const FormsyTextField = (props) => {
  const { setValue, isPristine, value, errorMessage, ...others } = props;
  const { showRequired, showError, isFormSubmitted, validationError, validationErrors, errorMessages, hasValue, isFormDisabled, setValidations, resetValue, isValid, isValidValue, isRequired, ...reduced } = {...others};
  return (
    <TextField
      fullWidth
      // disabled={isFormSubmitted}
      value={value || ''}
      onChange={e => setValue(e.currentTarget.value)}
      error={!isPristine && Boolean(errorMessage)}
      helperText={isPristine ? null : errorMessage}
      {...reduced}
    />
  );
};

FormsyTextField.propTypes = {
  ...formsyProptypes,
  ...TextField.propTypes
};

export default withFormsy(FormsyTextField);
